import React, { FC } from 'react'
import './index.scss'

export const FeedbackError: FC<any> = ({ message, ...props } : any) => (
    <div className="alert alert-danger text-center p-2" { ...props }>{ message }</div>
)
